/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Role of a team member
 * @export
 */
export const TeamMemberRole = {
    CAPTAIN: 'CAPTAIN',
    PLAYER: 'PLAYER',
    SUBSTITUTE: 'SUBSTITUTE'
} as const;
export type TeamMemberRole = typeof TeamMemberRole[keyof typeof TeamMemberRole];


export function instanceOfTeamMemberRole(value: any): boolean {
    for (const key in TeamMemberRole) {
        if (Object.prototype.hasOwnProperty.call(TeamMemberRole, key)) {
            if (TeamMemberRole[key as keyof typeof TeamMemberRole] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TeamMemberRoleFromJSON(json: any): TeamMemberRole {
    return TeamMemberRoleFromJSONTyped(json, false);
}

export function TeamMemberRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamMemberRole {
    return json as TeamMemberRole;
}

export function TeamMemberRoleToJSON(value?: TeamMemberRole | null): any {
    return value as any;
}

export function TeamMemberRoleToJSONTyped(value: any, ignoreDiscriminator: boolean): TeamMemberRole {
    return value as TeamMemberRole;
}

